import React, { Fragment } from 'react';
import classNames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import './index.scss';

const recommendMap: any = {
  0: 'no-good-icon',
  1: 'good-icon',
  Recommended: 'good-icon',
  'Not Recommended': 'no-good-icon',
};

export default function SteamRatingColumns({
  is_recommend,
  record_duration,
  review_duration,
  isColumns = true,
}: any) {
  const hasDuration = (num: number) => {
    if (!isNaN(num) && num > 0) {
      return true;
    }
    return false;
  };
  const { formatMessage } = useIntl();
  const renderDuration = (record_duration: number, review_duration: number) => {
    const hasRecordDuration = hasDuration(record_duration);
    const hasReviewDuration = hasDuration(review_duration);
    const textList = [];
    if (hasRecordDuration) {
      textList.push(
        formatMessage(
          { id: '{record_duration} hrs on record' },
          {
            record_duration: record_duration || 0,
          },
        ),
      );
    }
    if (hasReviewDuration) {
      textList.push(
        formatMessage(
          { id: '{review_duration} hrs at review time' },
          {
            review_duration: review_duration || 0,
          },
        ),
      );
    }

    return (
      <>
        {textList.map((item, index) => {
          const isEnd = index === 1;
          return (
            <Fragment key={item}>
              <p
                className="dbo-steam-rating-duration"
                style={isColumns && isEnd ? { marginTop: 5 } : {}}
              >
                {item}
              </p>
              {!isColumns && !isEnd && ', '}
            </Fragment>
          );
        })}
      </>
    );
  };

  return (
    <div
      className={classNames('dbo-steam-rating-columns-wrapper', {
        ['is-columns']: isColumns,
      })}
    >
      <SvgIcon
        className="dbo-steam-rating-icon-info"
        type={recommendMap[is_recommend]}
      />
      {renderDuration(record_duration, review_duration)}
    </div>
  );
}
